import React from "react";
import {
  SideNavigationV2Props,
  type CustomComponent,
} from "skedyul-ui/src/components/ui/SideNavigationV2";
import { SideNavigationComponentProps } from "@schemas/sideNavigation.schema";
import { EntitySetupSidebarHost } from "@/components/apps/EntitySetupSidebarHost";

export const entitySetupSidebarSchema = (
  args: SideNavigationComponentProps<
    CustomComponent,
    { subdomain: string }
  >,
): SideNavigationV2Props<CustomComponent> => {
  return {
    side: args.position,
    isOpen: args.state.sideNavigation[args.position].isOpen,
    width: args.width,
    component: {
      component: "Custom",
      // Stable host reads serializable params from Redux — avoids remounting
      // EntitySetupDialog when the layout schema regenerates.
      props: {
        children: React.createElement(EntitySetupSidebarHost),
      },
    },
  };
};
